import React, { useEffect, useState } from "react";
import { T } from "../../constants/theme";

/**
 * InlineBarChart — compact, tight, animates bars growing up from 0 on mount.
 * Pure React + inline styles. No ECharts, no CSS class dependency.
 */
const InlineBarChart = ({ data, labelKey, valueKey, color, formatValue, loading }) => {
  const [animated, setAnimated] = useState(false);
  const [hovered, setHovered] = useState(null);

  useEffect(() => {
    if (!loading && data && data.length > 0) {
      const t = setTimeout(() => setAnimated(true), 60);
      return () => clearTimeout(t);
    }
  }, [loading, data]);

  if (!data || data.length === 0) return null;

  const CHART_H = 52;
  const max = Math.max(...data.map((d) => d[valueKey]));

  return (
    <div style={{ marginBottom: "8px" }}>
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          gap: "3px",
          height: `${CHART_H}px`,
        }}
      >
        {data.map((d, i) => {
          const targetH = max > 0 ? Math.max(3, (d[valueKey] / max) * CHART_H) : 3;
          const isHov = hovered === i;
          return (
            <div
              key={i}
              title={`${d[labelKey]}: ${formatValue(d[valueKey])}`}
              onMouseEnter={() => setHovered(i)}
              onMouseLeave={() => setHovered(null)}
              style={{
                flex: 1,
                height: animated ? `${targetH}px` : "3px",
                background: isHov ? color : color + "cc",
                borderRadius: "3px 3px 0 0",
                transition: "height 0.65s cubic-bezier(0.22,1,0.36,1), background 0.15s",
                cursor: "default",
                position: "relative",
              }}
            >
              {isHov && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "calc(100% + 5px)",
                    left: "50%",
                    transform: "translateX(-50%)",
                    background: "#1a1a2e",
                    color: "#fff",
                    fontSize: "10px",
                    fontWeight: 600,
                    padding: "3px 7px",
                    borderRadius: "5px",
                    whiteSpace: "nowrap",
                    pointerEvents: "none",
                    zIndex: 10,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                  }}
                >
                  {formatValue(d[valueKey])}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div style={{ display: "flex", gap: "3px", marginTop: "4px" }}>
        {data.map((d, i) => (
          <div
            key={i}
            style={{
              flex: 1,
              textAlign: "center",
              fontSize: "9px",
              color: T.muted,
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            {d[labelKey]}
          </div>
        ))}
      </div>
    </div>
  );
};

export default InlineBarChart;
